import moment from 'moment';

export default ['$filter', function ($filter) {
    var angularDateFilter = $filter('date');
    var today = moment();
    var yesterday = moment().subtract(1, 'days');
    var tomorrow = moment().add(1, 'days');

    return function (aDate) {
        var date = moment(aDate);
        if (!aDate) {
            return '—';
        } else if (date.isSame(yesterday, 'd')) {
            return $filter('translate')('gateway.activity.date.filter.Yesterday');
        } else if (date.isBefore(today, 'd')) {
            var dateDifference = today.diff(date, 'days');
            if (dateDifference == 1) {
                return $filter('translate')('gateway.activity.date.filter.day ago', { days: dateDifference });
            } else {
                return $filter('translate')('gateway.activity.date.filter.days ago', { days: dateDifference });
            }
        } else if (date.isSame(today, 'd')) {
            return $filter('translate')('gateway.activity.date.filter.Today');
        } else if (date.isSame(tomorrow, 'd')) {
            return $filter('translate')('gateway.activity.date.filter.Tomorrow');
        } else if (date.isBefore(moment().endOf('isoWeek'), 'd')) {
            // Day is before or On the Sunday of current week ISO 8601 week format
            var day = '';
            switch (date.isoWeekday()) {
                case 1:
                    day = $filter('translate')('gateway.activity.date.filter.Monday');
                    break;
                case 2:
                    day = $filter('translate')('gateway.activity.date.filter.Tuesday');
                    break;
                case 3:
                    day = $filter('translate')('gateway.activity.date.filter.Wednesday');
                    break;
                case 4:
                    day = $filter('translate')('gateway.activity.date.filter.Thursday');
                    break;
                case 5:
                    day = $filter('translate')('gateway.activity.date.filter.Friday');
                    break;
                case 6:
                    day = $filter('translate')('gateway.activity.date.filter.Saturday');
                    break;
                case 7:
                    day = $filter('translate')('gateway.activity.date.filter.Sunday');
                    break;
                default:
                    return '—';
            }
            return day;
        }
        return angularDateFilter(aDate, 'shortDate');
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/filters/ActivityDateFilter.js
// module id = 1773
// module chunks = 0